import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { itIT } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT as datePickersItIT } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import 'moment/locale/it';

import {
	ApiProvider,
	DataProvider,
	FetchProvider,
	NavProvider,
	ToastProvider,
} from './components/contexts';

import {
	Layout,
	Routes
} from './components/common';

import { SnackbarProvider } from 'notistack';

const theme = createTheme(
	{
		palette: {
			primary: {
				main: "#0059b3",
			},
			secondary: {
				main: "#036",
			},
		},
		typography: {
			fontFamily: '"Titillium Web",Geneva,Tahoma,sans-serif'
		},
	},
	itIT,
	datePickersItIT
);

function App(props) {
	return (
		<BrowserRouter basename={props.baseUrl}>
			<ThemeProvider theme={theme}>
				<LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="itIT">
					<SnackbarProvider preventDuplicate maxSnack={5}>
						<ToastProvider>
							<FetchProvider>
								<ApiProvider>
									<DataProvider>
										<NavProvider>
											<Layout>
												<Routes />
											</Layout>
										</NavProvider>
									</DataProvider>
								</ApiProvider>
							</FetchProvider>
						</ToastProvider>
					</SnackbarProvider>
				</LocalizationProvider>
			</ThemeProvider>
		</BrowserRouter>
	);
}

export default App;
